/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import {
  NgxAuthComponent,
  NgxLoginComponent,
  NgxRegisterComponent,
  NgxLogoutComponent,
  NgxRequestPasswordComponent,
  NgxResetPasswordComponent,
  RegisterTenantComponent,
  TenantListComponent,
  PatientLoginComponent,
  PatientSignupComponent,
  PatientVideocallLoginComponent,
  ResetPasswordInsideAppComponent
} from './components'; 
import { PatientVideocallComponent } from './components/patient-videocall/patient-videocall.component';
import { DoctorSignupComponent } from './components/doctor/doctor-signup/doctor-signup.component';
import { PatientportalloginComponent } from './components/patientportallogin/patientportallogin.component';
import { PortalAppointmentBookingComponent } from './components/portal-appointment-booking-component/portal-appointment-booking-component.component';
import { BookingSummaryLoginComponent } from './components/booking-summary-login/booking-summary-login.component';
import { QueuemanagementComponent } from './components/queuemanagement/queuemanagement.component';
import { CareLoginComponent } from './components/care-login/care-login.component';

const routes: Routes = [{
  path: '',
  component: NgxAuthComponent,
  children: [
    {
      path: '',
      component: NgxLoginComponent,
    },
    {
      path: 'login',
      component: NgxLoginComponent,
    },
    {
      path: 'register/:userId',
      component: NgxRegisterComponent,
    },
    {
      path: 'logout',
      component: NgxLogoutComponent,
    },
    {
      path: 'request-password',
      component: NgxRequestPasswordComponent,
    },
    {
      path: 'reset-password',
      component: NgxResetPasswordComponent,
    },
    {
      path: 'register-tenant',
      component: RegisterTenantComponent,
    },
    {
      path: 'country-superadmin-tenant',
      component: RegisterTenantComponent,
    },
    {
      path: 'tenant-list',
      component: TenantListComponent,
    },
    {
      path: 'login/:newTenant',
      component: NgxLoginComponent,
    },
    {
      path: 'patient-login-iframe',
      component: PatientLoginComponent,
    }, 
    {
      path: 'patient-portal',
      component: PatientportalloginComponent,
    }, 
    {
      path: 'well-spring-login',
      component: PatientportalloginComponent,
      data: { wellSpringApp: true }
    },
    {
      path: 'well-spring-login/:tenantId',
      component: PatientportalloginComponent,
      data: { wellSpringApp: true }
    },
    {
      path: 'well-spring-login/:tenantId/traveller',
      component: PatientportalloginComponent,
      data: { wellSpringApp: true }
    },
    {
      path: 'well-spring-login/:tenantId/employer',
      component: PatientportalloginComponent,
      data: { wellSpringApp: true }
    },
    {
      path: 'well-spring-login/:tenantId/doctor',
      component: PatientportalloginComponent,
      data: { wellSpringApp: true }
    },
    {
      path: 'well-spring-login/:tenantId/foreign-worker',
      component: PatientportalloginComponent,
      data: { wellSpringApp: true }
    },
    // "Second Opinion" employee roles - role comes from the URL (invite link), not from the
    // in-page role-selector card grid (see PatientportalloginComponent.ngOnInit() reading
    // route.snapshot.data['employeeRole']).
    {
      path: 'well-spring-login/:tenantId/care-navigator',
      component: PatientportalloginComponent,
      data: { wellSpringApp: true, employeeRole: 'care-navigator' }
    },
    {
      path: 'well-spring-login/:tenantId/reviewer',
      component: PatientportalloginComponent,
      data: { wellSpringApp: true, employeeRole: 'reviewer' }
    },
    {
      path: 'care-sphere/:type',
      component: CareLoginComponent,
    },
    {
      path: 'care-sphere/:type/traveller',
      component: CareLoginComponent,
      data: { portalSubType: 'traveller' }
    },
    {
      path: 'care-sphere/:type/employer',
      component: CareLoginComponent,
      data: { portalSubType: 'employer' }
    },
    {
      path: 'care-sphere/:type/doctor',
      component: CareLoginComponent,
      data: { portalSubType: 'doctor' }
    },
    {
      path: 'care-sphere/:type/foreign-worker',
      component: CareLoginComponent,
      data: { portalSubType: 'foreign-worker' }
    },
    {
      path: 'patient-signup',
      component: PatientSignupComponent,
    },
    {
      path: 'doctor-signup',
      component: DoctorSignupComponent,
    },
    {
      path: 'reset-pwd-inside-app',
      component: ResetPasswordInsideAppComponent,
    },
    {
      path: 'patient-videocall-check/token/:roomID/id/:Id/:regId/:docId',
      component: PatientVideocallLoginComponent,
    },
    { path: 'patient-join-call/:roomId/:regId', component: PatientVideocallComponent },
    // { path: 'patient-portal-appointment-booking', component: PortalAppointmentBookingComponent },
    // { path: 'patient-portal-appointment-booking/:from', component: PortalAppointmentBookingComponent },
    // { path: 'patient-portal-booking-summary/:value1/:value2/:value3/:value4/:value5', component: BookingSummaryLoginComponent },
    { path: 'queue/:customerId/:passCode', component: QueuemanagementComponent },
    { path: 'queue/:customerId/:passCode/:deviceId', component:  QueuemanagementComponent },
  ],
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {
}
